// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5h-1";
export var standaloneTable = "_5h-0";